/* import core CSS (actually whole CSS for now, we can split it later) */
import style from '@style/style.scss';


// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/styles-tmp.js